import React__default from 'react';
import PropTypes from 'prop-types';

var propTypes = {
  /** Array of link/button objects. Each object must have a unique `key` and `children` (content/text) */
  links: PropTypes.arrayOf(PropTypes.shape({
    children: PropTypes.node.isRequired,
    key: PropTypes.string.isRequired,
    href: PropTypes.string,
    onClick: PropTypes.func,
    target: PropTypes.string
  }).isRequired).isRequired,
  /** Visual theme for color contrast */
  theme: PropTypes.oneOf(['default', 'inverse'])
};
function LinkListArrow(_ref) {
  var links = _ref.links,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? 'default' : _ref$theme;
  return /*#__PURE__*/React__default.createElement("ul", {
    className: "link-list-arrow"
  }, links.map(function (_ref2) {
    var children = _ref2.children,
      href = _ref2.href,
      key = _ref2.key,
      onClick = _ref2.onClick,
      target = _ref2.target;
    return /*#__PURE__*/React__default.createElement("li", {
      key: "linklistarrow-".concat(key)
    }, href ? /*#__PURE__*/React__default.createElement("a", {
      href: href,
      rel: target && 'noreferrer noopener',
      target: target
    }, /*#__PURE__*/React__default.createElement("span", {
      className: "icon-link-text"
    }, children, /*#__PURE__*/React__default.createElement("span", {
      "aria-hidden": "true",
      className: "link-arrow",
      "data-testid": "link-arrow"
    }))) : /*#__PURE__*/React__default.createElement("button", {
      className: "link-button",
      "data-theme": theme,
      onClick: onClick
    }, /*#__PURE__*/React__default.createElement("span", {
      className: "icon-link-text"
    }, children, /*#__PURE__*/React__default.createElement("span", {
      "aria-hidden": "true",
      className: "link-arrow",
      "data-testid": "link-arrow"
    }))));
  }));
}
LinkListArrow.propTypes = propTypes;

export { LinkListArrow as default };
//# sourceMappingURL=LinkListArrow.js.map
